'use strict'
const {
    migrateStylableComponentsByCompType
} = require('../helpers/stylableMigration/migrateStylableComponentsByCompType')

const SELECTABLE_CONTAINER_COMPTYPE = 'wixui.SelectableContainer'
const SELECTABLE_CONTAINER_NON_STYLABLE_SKIN = 'wixui.skins.SelectableContainer'

const migratePage = (structure, data, uniqueIdGenerator, clientSpecMap, magicObject) => {
    migrateStylableComponentsByCompType({
        magicObject,
        structure,
        data,
        uniqueIdGenerator,
        clientSpecMap,
        newSkin: SELECTABLE_CONTAINER_NON_STYLABLE_SKIN,
        compType: SELECTABLE_CONTAINER_COMPTYPE,
        useCssColor: true,
        selectorsMappings: {
            '.root': {
                name: 'root',
                removePrefix: true,
                properties: {
                    'background-color': 'background'
                }
            }
        }
    })
}

// DRAFT MIGRATION - this migration is not complete missing bug fixes & tests
module.exports = {
    name: 'selectableContainerStylesFixer',
    version: 0,
    experimentalVersions: [
        {experiment: 'dm_migrateSelectableContainerToNonStylable', version: 1},
        {experiment: 'dm_migrateBlocksWidgetsToNonStylable', version: 2}
    ],
    exec(pageJson, pageIdsArray, magicObject) {
        const {clientSpecMap} = magicObject
        const {uniqueIdGenerator} = magicObject.dataFixerUtils

        if (!magicObject.isExperimentOpen('dm_migrateSelectableContainerToNonStylable')) {
            return
        }

        const {data, structure} = pageJson
        migratePage(structure, data, uniqueIdGenerator, clientSpecMap, magicObject)
    },
    fixerRequiresReruns: true
}
